import {
  page,
  pageAction,
  pageModule,
  queryparam,
  userPermission,
} from '../interface/user';
export const ACTION = {
  LIST: 'list',
  ADD: 'new',
  VIEW: 'view',
};

export function urlSegment(mod: pageModule, action: pageAction, type = 'full') {
  //@ts-ignore
  if (['DASHBOARD_ROUTE', 'ACCESS_DENIED_ROUTE'].includes(mod)) {
    return UrlServices[mod];
  } else if (mod == 'AUTH_PAGE') {
    return UrlServices.AUTH_PAGE[mod][action];
  }
  return UrlServices.PAGE_URL[mod][action].URL;
}
export function lastUrlSegment(mod, action) {
  return UrlServices.PAGE_URL[mod][action].URL.split(/[/]+/).pop();
}
export function urlPermission(mod, action) {
  return action
    ? UrlServices.PAGE_URL[mod][action].permission
    : ({} as userPermission);
}
export function urlQueryParams(mod, action): queryparam[] {
  return UrlServices.PAGE_URL[mod][action].queryparam || [];
}
export class UrlServices {
  public static DASHBOARD_ROUTE = 'dashboard';
  public static ACCESS_DENIED_ROUTE = 'access_denied';
  public static AUTH_PAGE = {
    //USER_ROUTE :
    LOGIN_URL: '/' + 'login',
    PUBLIC_STAFF_LEAVE_URL: '/' + 'staff-leave-public',
    FORGOT_PASSWORD_URL: '/' + 'forgotPassword',
    RESET_PASSWORD_URL: '/' + 'reset',
    LOGOUT_URL: '/' + 'logout',
    ACTIVATE: '/' + 'activate',
  };
  public static PAGE_URL: page = {
    EMAIL: {
      LIST: {
        URL: '/email' + '/' + ACTION.LIST,
        permission: {} as userPermission,
      },
      ADD: {
        URL: '/email' + '/' + ACTION.ADD,
        permission: {} as userPermission,
      },
      VIEW: {
        URL: '/email' + '/' + ACTION.VIEW,
        permission: {} as userPermission,
      },
    },
    USER: {
      LIST: {
        URL: '/user' + '/' + ACTION.LIST,
        permission: { moduleName: 'USER', actionName: 'VIEW_ALL' },
      },
      ADD: {
        URL: '/user' + '/' + ACTION.ADD,
        permission: { moduleName: 'USER', actionName: 'ADD' },
      },
      VIEW: {
        URL: '/user' + '/' + ACTION.VIEW,
        permission: { moduleName: 'USER', actionName: 'READ' },
      },
      ROLE: {
        URL: '/user' + '/roles-list',
        permission: { moduleName: 'USER', actionName: 'MANAGE_ROLE' },
      },
    },
    MASTER: {
      ADDRESS: {
        URL: '/master' + '/location',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_LOCATION' },
      },
      OFFICE: {
        URL: '/master' + '/office',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_OFFICE' },
      },
      GENERAL: {
        URL: '/master' + '/general',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_OFFICE' },
      },
      HOMES: {
        URL: '/master' + '/homes',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_HOMES' },
      },
      EMAIL: {
        URL: '/master' + '/email',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_OFFICE' },
      },
      NOTIFICATION: {
        URL: '/master' + '/manage_notification',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_OFFICE' },
      },
      NOTIFICATION_EDIT: {
        URL: '/master' + '/notification',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_OFFICE' },
      },
      UPDATE_HOMES: {
        URL: '/master' + '/update-homes',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_HOMES' },
      },
      VIEW_HOMES: {
        URL: '/master' + '/view-homes',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_HOMES' },
      },
      UPDATE_EMAIL: {
        URL: '/master' + '/update-email',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_OFFICE' },
      },
      UPDATE_FORMS: {
        URL: '/master' + '/update-forms',
        permission: {
          moduleName: 'MASTER',
          actionName: 'MANAGE_EMAIL_TEMPLATES',
        },
      },
      FORMS: {
        URL: '/master' + '/forms',
        permission: {
          moduleName: 'MASTER',
          actionName: 'MANAGE_EMAIL_TEMPLATES',
        },
      },
      NEW_FORMS: {
        URL: '/master' + '/forms' + ACTION.ADD,
        permission: {
          moduleName: 'MASTER',
          actionName: 'MANAGE_EMAIL_TEMPLATES',
        },
      },
      MOBILE: {
        URL: '/master' + '/mobile-app',
        permission: {
          moduleName: 'MASTER',
          actionName: 'MANAGE_EMAIL_TEMPLATES',
        },
      },
      PAYROLE: {
        URL: '/master' + '/payroll',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_PAYROLL' },
      },
      BACKGROUND_TASK: {
        URL: '/master' + '/background-task',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_PAYROLL' },
      },
      DOCUMENT: {
        URL: '/master/document',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_PAYROLL' },
      },
      DOCUMENT_VIEW: {
        URL: '/master/documentInfo',
        permission: {} as userPermission,
      },
      NEW_DOCUMENT: {
        URL: '/master/new-document',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_PAYROLL' },
      },
      NOTICE: {
        URL: '/master' + '/notice',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_OFFICE' },
      },
      BIBLE_WORD: {
        URL: '/master' + '/bible-word',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_OFFICE' },
      },
      // Same reasoning as BIBLE_WORD/NOTICE above - no dedicated EXPORT_TEMPLATE
      // permission exists yet either side, reuses the same catch-all.
      EXPORT_TEMPLATE: {
        URL: '/master' + '/export-template',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_OFFICE' },
      },
      // No dedicated AUDIT permission module exists yet (backend or frontend) -
      // reuses MASTER/MANAGE_OFFICE, the same catch-all permission several other
      // generic Master admin pages (Notice, Bible Word, Email) already gate on.
      AUDIT_LOGS: {
        URL: '/master' + '/audit-logs',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_OFFICE' },
      },
      // Same reasoning as AUDIT_LOGS above - no dedicated BACKUP permission
      // exists yet either side, reuses the same catch-all.
      BACKUP: {
        URL: '/master' + '/backup',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_OFFICE' },
      },
      // Same reasoning as BACKUP above - no dedicated FILE_STORAGE permission
      // exists yet either side, reuses the same catch-all.
      FILE_STORAGE: {
        URL: '/master' + '/file-storage',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_OFFICE' },
      },
    },
    STAFF: {
      LIST: {
        URL: '/staff' + '/' + ACTION.LIST,
        permission: { moduleName: 'STAFF', actionName: 'VIEW_ALL' },
      },
      ADD: {
        URL: '/staff' + '/' + ACTION.ADD,
        permission: { moduleName: 'STAFF', actionName: 'ADD' },
      },
      VIEW: {
        URL: '/staff' + '/' + ACTION.VIEW,
        permission: { moduleName: 'STAFF', actionName: 'READ' },
      },
      TRANSFER_LIST: {
        URL: '/staff' + '/' + 'transfer-list',
        permission: { moduleName: 'STAFF_TRANSFER', actionName: 'VIEW_ALL' },
      },
      TRANSFER_ADD: {
        URL: '/staff' + '/' + 'new-transfer',
        permission: { moduleName: 'STAFF_TRANSFER', actionName: 'ADD' },
      },
      DEDICATION_LIST: {
        URL: '/staff' + '/' + 'dedication',
        permission: { moduleName: 'DEDICATION', actionName: 'VIEW_ALL' },
      },
      DEDICATION_ADD: {
        URL: '/staff' + '/' + 'new-dedication',
        permission: { moduleName: 'DEDICATION', actionName: 'ADD' },
      },
      REPORT_LIST: {
        URL: '/staff' + '/' + 'viewAll_report',
        permission: {
          moduleName: 'MONTHLY_REPORT_STAFF',
          actionName: 'VIEW_ALL',
        },
        queryparam: [{ key: 'id', value: 'my_report', actionName: 'MY_SELF' }],
      },
      REPORT_ADD: {
        URL: '/staff' + '/' + 'modify_report',
        permission: { moduleName: 'MONTHLY_REPORT_STAFF', actionName: 'ADD' },
        queryparam: [{ key: 'id', value: 'my_report', actionName: 'MY_SELF' }],
      },
      REPORT_STATS: {
        URL: '/staff' + '/' + 'modify_report_stats',
        permission: {
          moduleName: 'MONTHLY_REPORT_STAFF',
          actionName: 'PROCESS',
        },
        queryparam: [{ key: 'mode', value: 'report' }],
      },
    },

    SPONSOR: {
      LIST: {
        URL: '/sponsor' + '/' + ACTION.LIST,
        permission: { moduleName: 'SPONSOR', actionName: 'VIEW_ALL' },
      },
      ADD: {
        URL: '/sponsor' + '/' + ACTION.ADD,
        permission: { moduleName: 'SPONSOR', actionName: 'ADD' },
      },
      VIEW: {
        URL: '/sponsor' + '/' + ACTION.VIEW,
        permission: { moduleName: 'SPONSOR', actionName: 'READ' },
      },
      SPONSORSHIP_ADD: {
        URL: '/sponsor' + '/update',
        permission: { moduleName: 'SPONSORSHIP', actionName: 'ADD' },
      },
      SPONSORSHIP: {
        URL: '/sponsor' + '/sponsorship',
        permission: { moduleName: 'SPONSORSHIP', actionName: 'VIEW_ALL' },
      },
      SPONSORSHIP_ALLOTMENT: {
        URL: '/sponsor' + '/sponsorship_allotment',
        permission: { moduleName: 'SPONSORSHIP', actionName: 'ALLOTMENT' },
      },
      SPONSOR_GIFT: {
        URL: '/sponsor' + '/gift_view_All',
        permission: { moduleName: 'SPONSOR_GIFT', actionName: 'VIEW_ALL' },
      },
      SPONSOR_GIFT_ADD: {
        URL: '/sponsor' + '/gift_add',
        permission: { moduleName: 'SPONSOR_GIFT', actionName: 'ADD' },
      },
      DONATION_LIST: {
        URL: '/sponsor' + '/donation-list',
        permission: { moduleName: 'DONATION', actionName: 'VIEW_ALL' },
      },
      NEW_DONATION: {
        URL: '/sponsor' + '/new-donation',
        permission: { moduleName: 'DONATION', actionName: 'ADD' },
      },
      ASSIGN_INFO: {
        URL: '/sponsor' + '/assign-info',
        permission: { moduleName: 'DONATION_ALLOTMENT', actionName: 'ADD' },
      },
    },
    DONATION: {
      CAMPAIGN_LIST: {
        URL: '/donation' + '/campaign-list',
        permission: {
          moduleName: 'DONATION_ALLOTMENT',
          actionName: 'VIEW_ALL',
        } as userPermission,
      },
      NEW_CAMPAIGN: {
        URL: '/donation' + '/new-campaign',
        permission: {
          moduleName: 'DONATION_ALLOTMENT',
          actionName: 'ADD',
        } as userPermission,
      },
      DONATION_ALLOTMENT_LIST: {
        URL: '/donation' + '/donation-allotment',
        permission: {
          moduleName: 'DONATION_ALLOTMENT',
          actionName: 'VIEW_ALL',
        },
      },
    },
    CHILD: {
      LIST: {
        URL: '/child' + '/' + ACTION.LIST,
        permission: { moduleName: 'CHILD', actionName: 'VIEW_ALL' },
      },
      ADD: {
        URL: '/child' + '/' + ACTION.ADD,
        permission: { moduleName: 'CHILD', actionName: 'ADD' },
      },
      VIEW: {
        URL: '/child' + '/' + ACTION.VIEW,
        permission: { moduleName: 'CHILD', actionName: 'READ' },
      },
      REPORT_LIST: {
        URL: '/child' + '/' + 'viewAll_report',
        permission: {
          moduleName: 'MONTHLY_REPORT_CHILD',
          actionName: 'VIEW_ALL',
        },
      },
      REPORT_ADD: {
        URL: '/child' + '/' + 'add_report',
        permission: { moduleName: 'MONTHLY_REPORT_CHILD', actionName: 'ADD' },
      },
      EDU_YEARLY_UPDATE_LIST: {
        URL: '/child' + '/' + 'education-yearly-update',
        permission: { moduleName: 'CHILD_EDUCATION', actionName: 'VIEW_ALL' },
      },
    },
    CHURCH: {
      LIST: {
        URL: '/church' + '/' + ACTION.LIST,
        permission: { moduleName: 'CHURCH', actionName: 'VIEW_ALL' },
      },
      ADD: {
        URL: '/church' + '/' + ACTION.ADD,
        permission: { moduleName: 'CHURCH', actionName: 'ADD' },
      },
      VIEW: {
        URL: '/church' + '/' + ACTION.VIEW,
        permission: { moduleName: 'CHURCH', actionName: 'READ' },
      },
      REPORT_LIST: {
        URL: '/church' + '/' + 'viewAll_report',
        permission: {
          moduleName: 'SIX_MONTH_CHURCH_REPORT',
          actionName: 'VIEW_ALL',
        },
      },
      REPORT_ADD: {
        URL: '/church' + '/' + 'add_report',
        permission: {
          moduleName: 'SIX_MONTH_CHURCH_REPORT',
          actionName: 'ADD',
        },
        queryparam: [{ key: 'mode', value: 'VIEW', actionName: 'READ' }],
      },
      INCOME_LIST: {
        URL: '/church' + '/' + 'viewAll_church_income',
        permission: { moduleName: 'CHURCH_INCOME', actionName: 'VIEW_ALL' },
      },
      INCOME_ADD: {
        URL: '/church' + '/' + 'new_church_income',
        permission: { moduleName: 'CHURCH_INCOME', actionName: 'ADD' },
      },
      EXPENSE_LIST: {
        URL: '/church' + '/' + 'all_church_expense',
        permission: { moduleName: 'CHURCH_EXPENSE', actionName: 'VIEW_ALL' },
      },
      EXPENSE_ADD: {
        URL: '/church' + '/' + 'manage_expense',
        permission: { moduleName: 'CHURCH_EXPENSE', actionName: 'ADD' },
      },
      FIN_REPORT_LIST: {
        URL: '/church' + '/' + 'fin_report',
        permission: { moduleName: 'CHURCH_EXPENSE', actionName: 'VIEW_ALL' },
      },
      MEMBER_ADD: {
        URL: '/church' + '/' + 'add_member',
        permission: { moduleName: 'CHURCH_MEMBER', actionName: 'ADD' },
      },
      MEMBER_LIST: {
        URL: '/church' + '/' + 'add_viewAll',
        permission: { moduleName: 'CHURCH_MEMBER', actionName: 'VIEW_ALL' },
      },
      CHURCH_COLLECTION: {
        URL: '/church' + '/' + 'collection',
        permission: {
          moduleName: 'DONATION_ALLOTMENT',
          actionName: 'VIEW_ALL',
          sponsorship_module: ['3'],
        },
      },
      CHURCH_COLLECTION_VIEW: {
        URL: '/church' + '/' + 'collection' + ACTION.VIEW,
        permission: {
          moduleName: 'DONATION_ALLOTMENT',
          actionName: 'VIEW_ALL',
          sponsorship_module: ['3'],
        },
      },
      PROGRESS_REPORT_LIST: {
        URL: '/church' + '/' + 'progress' + ACTION.LIST,
        permission: { moduleName: 'CHURCH_PROGRESS', actionName: 'VIEW_ALL' },
      },
      NEW_PROGRESS_REPORT: {
        URL: '/church' + '/' + 'progress' + ACTION.ADD,
        permission: { moduleName: 'CHURCH_PROGRESS', actionName: 'ADD' },
      },
      PROGRESS_REPORT_VIEW: {
        URL: '/church' + '/' + 'progress' + ACTION.VIEW,
        permission: { moduleName: 'CHURCH_PROGRESS', actionName: 'VIEW_ALL' },
      },
    },
    COLLECTION: {
      CHURCH_LIST: {
        URL: '/collection' + '/' + 'church' + ACTION.LIST,
        permission: { moduleName: 'DONATION', actionName: 'MANAGE_COLLECTION' },
      },
      PAYMENT_LIST: {
        URL: '/collection' + '/' + 'payment' + ACTION.LIST,
        permission: { moduleName: 'CAMPAIGN_PAYMENT', actionName: 'VIEW_ALL' },
      },
      PAYMENT_NEW: {
        URL: '/collection' + '/' + 'newPayment' + ACTION.ADD,
        permission: { moduleName: 'CAMPAIGN_PAYMENT', actionName: 'ADD' },
      },
      SPONSOR_LIST: {
        URL: '/collection' + '/' + 'sponsor-list' + ACTION.ADD,
        permission: { moduleName: 'DONATION', actionName: 'MANAGE_COLLECTION' },
      },
    },
    ASSET: {
      LIST: {
        URL: '/asset' + '/' + ACTION.LIST,
        permission: { moduleName: 'ASSET', actionName: 'VIEW_ALL' },
      },
      ADD: {
        URL: '/asset' + '/' + ACTION.ADD,
        permission: { moduleName: 'ASSET', actionName: 'ADD' },
      },
      VIEW: {
        URL: '/asset' + '/' + ACTION.VIEW,
        permission: { moduleName: 'ASSET', actionName: 'READ' },
      },
      TRANSFER: {
        URL: '/asset' + '/' + 'transfer',
        permission: { moduleName: 'ASSET', actionName: 'TRANSFER' },
      },
    },
    ACTIVITY: {
      VIEW_ALL: {
        URL: '/activity' + '/' + ACTION.LIST,
        permission: { moduleName: 'ACTIVITY', actionName: 'VIEW_ALL' },
      },
      ADD: {
        URL: '/activity' + '/' + ACTION.ADD,
        permission: { moduleName: 'ACTIVITY', actionName: 'ADD' },
      },
      VIEW: {
        URL: '/activity' + '/' + ACTION.VIEW,
        permission: {
          moduleName: 'ACTIVITY',
          actionName: 'READ',
        } as userPermission,
      },
    },
    REPORT: {
      STAFF_FLAT_REPORT: {
        URL: '/report' + '/getAll',
        permission: {} as userPermission,
      },
      FLAT_REPORT: {
        URL: '/report' + '/flat_report',
        permission: { moduleName: 'STAFF', actionName: 'FLAT_REPORT' },
      },
      CHILD_FLAT_REPORT: {
        URL: '/report' + '/getAll',
        permission: { moduleName: 'CHILD', actionName: 'FLAT_REPORT' },
      },
      SPONSOR_FLAT_REPORT: {
        URL: '/report' + '/getAll',
        permission: { moduleName: 'SPONSOR', actionName: 'FLAT_REPORT' },
      },
      CHURCH_FLAT_REPORT: {
        URL: '/report' + '/getAll',
        permission: { moduleName: 'CHURCH', actionName: 'FLAT_REPORT' },
      },
      MEMEBER_FLAT_REPORT: {
        URL: '/report' + '/getAll',
        permission: { moduleName: 'CHURCH_MEMBER', actionName: 'FLAT_REPORT' },
      },
      ASSET_FLAT_REPORT: {
        URL: '/report' + '/getAll',
        permission: { moduleName: 'ASSET', actionName: 'FLAT_REPORT' },
      },
      APPLICATION_FLAT_REPORT: {
        URL: '/report' + '/getAll',
        permission: { moduleName: 'APPLICATION', actionName: 'FLAT_REPORT' },
      },
      PAYROLL_FLAT_REPORT: {
        URL: '/report' + '/getAll',
        permission: { moduleName: 'PAYROLL', actionName: ['PROCESS','FLAT_REPORT',"APPROVE","VERIFY"]},
      },
    },
    APPLICATION: {
      LIST: {
        URL: '/application' + '/' + ACTION.LIST,
        permission: { moduleName: 'APPLICATION', actionName: 'VIEW_ALL' },
        queryparam: [
          { key: 'id', value: 'my_self', actionName: 'MY_SELF' },
          { key: 'id', value: 'welfare', actionName: 'MANAGE_WELFARE' },
        ],
      },
      WELFARE_LIST: {
        URL: `/application/welfare-${ACTION.LIST}`,
        permission: { moduleName: 'APPLICATION', actionName: 'MANAGE_WELFARE' },
      },
      FIN_LIST: {
        URL: '/application' + '/fin-' + ACTION.LIST,
        permission: { moduleName: 'APPLICATION', actionName: 'VIEW_ALL' },
      },
      ADD: {
        URL: '/application' + '/' + ACTION.ADD,
        queryparam: [{ key: 'id', value: 'my_self', actionName: 'MY_SELF' }],
        permission: { moduleName: 'APPLICATION', actionName: 'ADD' },
      },
      VIEW: {
        URL: '/application' + '/' + ACTION.VIEW,
        permission: {} as userPermission,
      },
    },
    ATTENDANCE: {
      LIST: {
        URL: '/attendance/' + ACTION.LIST,
        permission: {
          moduleName: 'ATTENDANCE',
          actionName: 'VIEW_ALL',
        } as userPermission,
      },
      APPLICATION_LIST: {
        URL: '/attendance/' + 'leave' + ACTION.LIST,
        permission: {
          moduleName: 'LEAVE',
          actionName: 'VIEW_ALL',
        } as userPermission,
        queryparam: [{ key: 'mode', value: 'my_self', actionName: 'MY_SELF' }],
      },
      NEW_APPLICATION: {
        URL: '/attendance/' + 'leave' + ACTION.ADD,
        permission: {
          moduleName: 'LEAVE',
          actionName: 'ADD',
        } as userPermission,
        queryparam: [{ key: 'mode', value: 'my_self', actionName: 'MY_SELF' }],
      },
      HOLIDAY_LIST: {
        URL: '/attendance/' + 'holiday' + ACTION.LIST,
        permission: {
          moduleName: 'HOLIDAY',
          actionName: 'VIEW_ALL',
        } as userPermission,
      },
      HOLIDAY_NEW: {
        URL: '/attendance/' + 'holiday' + ACTION.ADD,
        permission: {
          moduleName: 'HOLIDAY',
          actionName: 'ADD',
        } as userPermission,
      },
      MANAGEMENT: {
        URL: '/attendance/' + 'management',
        permission: {
          moduleName: 'ATTENDANCE',
          actionName: 'PROCESS',
        } as userPermission,
      },
    },
    PAYROLE: {
      LIST: {
        URL: '/payroll' + '/list',
        permission: {
          moduleName: 'PAYROLL',
          actionName: ['VIEW_ALL', 'MANAGE_PAYSLIP'],
        } as userPermission,
      },
      STATEMENT: {
        URL: '/payroll' + '/statement',
        permission: {
          moduleName: 'PAYROLL',
          actionName: 'VIEW_ALL',
        } as userPermission,
      },
      STATEMENT_GENERATOR: {
        URL: '/payroll' + '/statementgenerator',
        permission: {
          moduleName: 'PAYROLL',
          actionName: 'UPDATE',
        } as userPermission,
      },
      ALLOWANCE_LIST: {
        URL: '/payroll' + '/allowance' + ACTION.LIST,
        permission: {
          moduleName: 'PAYROLL_ALLOWANCE',
          actionName: 'VIEW_ALL',
        } as userPermission,
        //@ts-ignore
        deductionPermission: {
          moduleName: 'PAYROLL_DEDUCTION',
          actionName: 'VIEW_ALL',
        } as userPermission,
      },
      NEW_ALLOWANCE: {
        URL: '/payroll' + '/allowance' + ACTION.ADD,
        permission: {
          moduleName: 'PAYROLL_ALLOWANCE',
          actionName: 'VIEW_ALL',
        } as userPermission,
      },
      NEW_DEDUCTION: {
        URL: '/payroll' + '/deduction' + ACTION.ADD,
        permission: {
          moduleName: 'PAYROLL_DEDUCTION',
          actionName: 'VIEW_ALL',
        } as userPermission,
      },
      INFO_ALLOWANCE: {
        URL: '/payroll' + '/allowance' + ACTION.VIEW,
        permission: {
          moduleName: 'PAYROLL_ALLOWANCE',
          actionName: 'READ',
        } as userPermission,
      },
      PAYROLL_LOG: {
        URL: '/payroll' + '/log' + ACTION.LIST,
        permission: {
          moduleName: 'PAYROLL',
          actionName: 'VIEW_ALL',
        } as userPermission,
      },
      EB_LIST: {
        URL: '/payroll' + '/eb' + ACTION.LIST,
        permission: {
          moduleName: 'PAYROLL_BULK',
          actionName: 'VIEW_ALL',
        } as userPermission,
      },
      NEW_EB: {
        URL: '/payroll' + '/eb' + ACTION.ADD,
        permission: {
          moduleName: 'PAYROLL_BULK',
          actionName: 'ADD',
        } as userPermission,
      },
      REMINDER_LIST: {
        URL: '/payroll' + '/remainder-' + ACTION.LIST,
        permission: {
          moduleName: 'PAYROLL_REMINDER',
          actionName: 'VIEW_ALL',
        } as userPermission,
      },
      ADD_REMINDER: {
        URL: '/payroll' + '/remainder-' + ACTION.ADD,
        permission: {
          moduleName: 'PAYROLL_REMINDER',
          actionName: 'ADD',
        } as userPermission,
      },
      INFO_REMINDER: {
        URL: '/payroll' + '/remainder-' + ACTION.VIEW,
        permission: {
          moduleName: 'PAYROLL',
          actionName: 'VIEW_ALL',
        } as userPermission,
      },
      FORECAST_REPORT: {
        URL: '/payroll' + '/forecastReport',
        permission: {
          moduleName: 'PAYROLL',
          actionName: 'FORECAST_REPORT',
        } as userPermission,
      },
      STAFF_PAYSLIP: {
        URL: '/payroll' + '/myPayslip',
        permission: {
          moduleName: 'STAFF',
          actionName: 'MY_SELF',
        } as userPermission,
      },
    },
    ACCOUNT: {
      NEW_ACCOUNT: {
        URL: '/account' + '/account' + ACTION.ADD,
        permission: {
          moduleName: 'ACCOUNT',
          actionName: 'ADD',
        } as userPermission,
      },
      ACCOUNT_LIST: {
        URL: '/account' + '/account' + ACTION.LIST,
        permission: {
          moduleName: 'ACCOUNT',
          actionName: 'VIEW_ALL',
        } as userPermission,
        queryparam: [{ key: 'mode', value: 'my_self', actionName: 'MY_SELF' }],
      },
      ACCOUNT_VIEW: {
        URL: '/account' + '/account' + ACTION.VIEW,
        permission: {
          moduleName: 'ACCOUNT',
          actionName: ['READ', 'MY_SELF'],
        } as userPermission,
      },
      TRANSACTION_LIST: {
        URL: '/account' + '/transaction' + ACTION.LIST,
        permission: {
          moduleName: 'ACCOUNT_TRANSACTION',
          actionName: 'VIEW_ALL',
        } as userPermission,
      },
      NEW_TRANSACTION: {
        URL: '/account' + '/transaction' + ACTION.ADD,
        permission: {
          moduleName: 'ACCOUNT_TRANSACTION',
          actionName: 'ADD',
        } as userPermission,
      },
      REPORT: {
        URL: '/account' + '/report',
        permission: {
          moduleName: 'ACCOUNT',
          actionName: 'STATS_REPORT',
        } as userPermission,
      },
    },
  };
}
